"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScreenSteps = void 0;
var react_1 = require("react");
exports.useScreenSteps = function (_a) {
    var initialStep = _a.initialStep, steps = _a.steps;
    var _b = react_1.useState(initialStep), step = _b[0], setStep = _b[1];
    var nextStep = function () {
        var currentStepIndex = getCurrectStepIndex();
        if (currentStepIndex + 1 >= steps.length)
            return;
        setStep(steps[currentStepIndex + 1]);
    };
    var prevStep = function () {
        var currentStepIndex = getCurrectStepIndex();
        if (currentStepIndex < 1)
            return;
        setStep(steps[currentStepIndex - 1]);
    };
    var getCurrectStepIndex = function () {
        var currentStepIndex = 0;
        steps.forEach(function (_step, i) {
            if (_step === step)
                currentStepIndex = i;
        });
        return currentStepIndex;
    };
    return {
        step: step,
        stepsCount: steps.length,
        nextStep: nextStep,
        prevStep: prevStep,
    };
};
